import cn from 'classnames';
import { IframeHTMLAttributes, useState } from 'react';

type YoutubeVideoProps = IframeHTMLAttributes<HTMLIFrameElement> & {
  src: string;
  title: string;
};

export const YoutubeVideo = ({ src, title, className, ...props }: YoutubeVideoProps) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  return (
    <div className={cn('relative w-full aspect-video', className)}>
      {!isLoaded && <div className="h-full bg-gray-200 animate-pulse rounded-xl" />}
      <iframe
        className="absolute top-0 left-0 w-full h-full rounded-xl"
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        loading="lazy"
        aria-label={title}
        onLoad={() => setIsLoaded(true)}
        {...props}
      />
    </div>
  );
};
